







































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CreateFaqArticleRequest from '@/models/FaqArticles/CreateFaqArticleRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';


@Component({
    name: 'FaqArticleCreate'
})
export default class extends GiganautVueDialog {

  public entity = new CreateFaqArticleRequest();
  public editorKey = 0;
  public editorReady = false;

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.editorReady = false;
      this.entity = new CreateFaqArticleRequest();
      this.entity.faqCategoryId = AgencySettingsModule.currentFaqCategory.id;
      this.editorKey++;
      this.$nextTick(() => {
        this.editorReady = true;
      });
    } else {
      this.editorReady = false;
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }
    await AgencySettingsModule.createFaqArticle(this.entity)
    this.dialog = false;
  }
}
